import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { take } from 'rxjs/operators';
import { NamService } from 'src/app/servizi/nam/nam.service';
import { ProjectService } from 'src/app/servizi/nam/project.service';
import { TemplateService } from 'src/app/servizi/nam/template.service';
import { WorldService } from 'src/app/servizi/nam/world.service';
import { UtilsService } from 'src/app/servizi/utils.service';
import { Collection, ConfigApiInterface, Field } from '../model/config-api-response.interface';
import { NamApiResponse } from '../model/nam-api-response.interface';
import { createRelativeItemFromUrnAndConfig, getCollectionDataset, getCollectionName } from '../object-utils';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { NamSelectedObjectService } from 'src/app/servizi/nam/nam-object-selected.service';
import { combineLatest } from 'rxjs';


@Component({
  selector: 'app-object-details',
  templateUrl: './object-details.component.html',
  styleUrls: ['./object-details.component.scss']
})
export class ObjectDetailsComponent implements OnInit, OnChanges {

  //Data object like Feature
  // {field: {type: sting, value: any}}
  private _objectData;
  private _urn: string = "";
  @Input() 
  set objectData(objectdata){
    // console.log('objectData: ',objectdata);
    if (
      objectdata &&
      Object.keys(objectdata).length > 0 &&
      Object.getPrototypeOf(objectdata) === Object.prototype
    ) {
      this._objectData = objectdata.properties;
      this._urn = objectdata.id;
      //
      this.initComponentVariables();
    }
  }
  get objectData() {
    return this._objectData;
  }

  get urn() {
    return this._urn;
  }

  get collectionName() {
    return this._urn ? this._urn.split("V")[3].split("Z")[1] : "";
  }

  // Tells whether a feature can be deleted or not.
  @Input() deletable: boolean = false;
  editable: boolean = false;

  // 
  collection: Collection = null;
  formFields: { [key: string]: { model: string } } = {};

  fieldList: Field[] = [];
  icons = { faTrash };

  editing: boolean = false;

  config = null;
  enumerators = null;

  // todo: extract utils
  constructor(
    private namService: NamService,
    private projectService: ProjectService,
    public templateService: TemplateService,
    private utils: UtilsService,
    private worldService: WorldService,
    private namSelectedObjectService: NamSelectedObjectService,
  ) { }

  ngOnInit(): void {
  }

  toggleEditing() {
    if (!this.collection.actions.includes("edit")) {
      //If collection is not editable do not allow change of variable editing.
      this.editing = false;
    } else {
      this.editing = !this.editing;
      //Reset the form when exits the editing
      if (!this.editing) {
        this.resetForm();
      }
    }

  }

  validateSalvaObject(): boolean {
    this.fieldList.forEach((element) => {
      //Validate each field
    });
    return true;
  }

  async salvaObjectDetails() {
    let body = null;
    if (this.validateSalvaObject()) {
      body = {};
      this.fieldList.forEach((element) => {
        // Only pick changed fields.
        if (this.formFields[element.name].model != this._objectData[element.name]) {
          //Validate each field
          body[element.name] = this.formFields[element.name].model;
        }
      });
    }

    await this.projectService.getProject();

    // todo: extract, use nam.service updateFeature ...
    // Save updated fields to the BE.
    let url = this.utils.creaURL('feature', 'update');
    let params = {};
    params["project_id"] = this.projectService.projectId;
    params["world_urn"] = this.worldService.getWorldInfo().world_urn;
    params["feature"] = JSON.stringify({
      "type": "Feature",
      "id": this._urn,
      "properties": body
    });

    combineLatest([this.namService.getApiConfiguration(), (this.utils.getRequest(url, params) as Observable<NamApiResponse<any>>)])
      .subscribe(([config,response]) => {
      // Make sure no error occurred. If so, do not exit edit mode.
      if (response && response.error == 0) {
        // Close editing.
        this.toggleEditing();
        // 
        const containerAsRelatedItem =  createRelativeItemFromUrnAndConfig(this._urn, config);
        this.namSelectedObjectService.selectedObjectForInfo = containerAsRelatedItem;
        
      } else {
        // TODO Show the user an error message.
      }
    });
  }

  /**
   * Returns the form values to the ones comming from the objectData
   */
  resetForm() {
    this.fieldList = this.collection.fields.filter((element) => {
      //Filter out elements that are not visible or that are joins
      //Join elements go to the related items.
      return element.visible && !element.join;
    });

    this.fieldList = this.fieldList.map((element) => {
      this.formFields[element.name] = {
        model: this._objectData[element.name]
      }
      return element;
    });
  }

  /**
   * Reset all variables to inital state and get again all the configuration to assemble the 
   * dynamic fields.
   */
  async initComponentVariables() {
    this.editing = false;
    this.collection = null;
    this.enumerators = null;
    this.fieldList = [];

    //let configurationData: Data = null;
    await this.namService.getApiConfiguration()
      .pipe(take(1))
      .subscribe((config: ConfigApiInterface) => {
        let name = getCollectionName(this._urn);
        let dataset = getCollectionDataset(this._urn);
        let nameToFind = dataset + "." + name;
        let collections: Collection[] = config.data.collections;

        this.collection = collections.find((element) => {
          return element.name == nameToFind;
        })

        this.enumerators = {};
        let enumerators = config.data.enumerators;
        enumerators.forEach((element) => {
          this.enumerators[element.name] = element.values;
        });

        let editableFields = this.collection.fields.filter((element) => {
          return !element.readonly;
        });
        this.editable = this.collection.actions.includes("edit") && editableFields.length > 0;

        this.resetForm();
      });
  }

  onDeleteFeature() {
    // Retrieve the current feature's container urn in order to change view after it's gone.
    const containerField = this.collection.fields.filter((element) => element.is_container)[0];
    const containerUrn = JSON.parse(this._objectData[containerField.name][0]).urn;

    combineLatest([
      this.namService.getApiConfiguration(),
      this.namService.deleteFeature(this._urn, this.projectService.projectId, this.worldService.getWorldInfo().world_urn)
    ]).subscribe(([config,response]) => {
        if (response && response.error == 0) {
          // call nam selected object pass container
          // console.log('update info with the container object response: ', response);
          const containerAsRelatedItem = createRelativeItemFromUrnAndConfig(containerUrn, config);
          this.namSelectedObjectService.selectedObjectForInfo = containerAsRelatedItem;
          this.namSelectedObjectService.clearHistory = 0;
        } else {
          // TODO Show the user an error message.
          console.log('error');
        }
      })
  }

  /**
   * Detect when the objectData input value changes and rebuild the component.
   * This is usefull when the object selected changes and the data must be rebuilt. 
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.objectData) {
      //this.objectData = changes.objectData.currentValue;
      if (this.templateService.addingTemplate) {
        this.templateService.cancelTemplate();
      }

    }
  }

}
